// src/services/donHangService.js
import api from "@/api";

const BASE_URL = "/api/don-hang";

/**
 * API service cho Quản lý Đơn hàng (khớp DonHangController)
 */
export const DonHangApi = {
  // === TÀI XẾ ===

  getMyOrdersList(params) {
    return api.get(`${BASE_URL}/cua-toi`, { params }).then((res) => res.data);
  },

  getMyActiveOrders() {
    return api.get(`${BASE_URL}/cua-toi/active`).then((res) => res.data);
  },
  driverClaimDonHang(id) {
    return api.post(`${BASE_URL}/${id}/claim`).then((res) => res.data);
  },
  driverDenDiemDung(diemDungId) {
    return api
      .post(`${BASE_URL}/diem-dung/${diemDungId}/den`)
      .then((res) => res.data);
  },
  driverXacMinhGiaoHang(diemDungId, taiXeId, imageUrl) {
    return api.post(
      `${BASE_URL}/diem-dung/${diemDungId}/driver-xac-minh`,
      null,
      { params: { taiXeId, imageUrl } }
    );
  },

  driverHoanThanhDiemDung(diemDungId) {
    return api
      .post(`${BASE_URL}/diem-dung/${diemDungId}/hoan-thanh`)
      .then((res) => res.data);
  },
  driverThatBai(id, lyDo) {
    return api
      .post(`${BASE_URL}/${id}/that-bai`, null, { params: { lyDo } })
      .then((res) => res.data);
  }, // === CHUNG ===

  getById(id) {
    return api.get(`${BASE_URL}/${id}`).then((res) => res.data);
  }, // === SALES ===

  create(payload) {
    return api.post(BASE_URL, payload).then((res) => res.data);
  },
  listSales(params) {
    return api
      .get(`${BASE_URL}/list-sales`, { params })
      .then((res) => res.data);
  },
  listSalesAll(params) {
    return api
      .get(`${BASE_URL}/list-sales/all`, { params })
      .then((res) => res.data);
  },
  salesConfirm(id, payload) {
    return api
      .post(`${BASE_URL}/${id}/sales-confirm`, payload)
      .then((res) => res.data);
  },
  salesCancel(id) {
    return api.post(`${BASE_URL}/${id}/sales-cancel`).then((res) => res.data);
  }, // === KHO ===

  listKho(params) {
    return api.get(`${BASE_URL}/list-kho`, { params }).then((res) => res.data);
  }, // --- API MỚI CHO NV KHO ---
  /**
   * NV Kho: Lấy danh sách nhiệm vụ (Điểm dừng) CỦA TÔI
   * GET /api/don-hang/diem-dung/my-tasks
   * Trả về List<DonHangDiemDungResponse> (đã bao gồm 'donHang' cha)
   */ getMyKhoTasks(params) {
    return api
      .get(`${BASE_URL}/diem-dung/my-tasks`, { params })
      .then((res) => res.data);
  },
  /**
   * NV Kho: Báo cáo "Đã soạn xong"
   * POST /api/don-hang/diem-dung/{diemDungId}/soan-xong
   */
  khoBaoCaoSoanXong(diemDungId, imageUrl) {
    return api
      .post(`${BASE_URL}/diem-dung/${diemDungId}/soan-xong`, null, {
        params: { imageUrl },
      })
      .then((res) => res.data);
  },

  // API MỚI
  khoBaoCaoThieuHang(diemDungId, ghiChuThieuHang) {
    return api
      .post(`${BASE_URL}/diem-dung/${diemDungId}/bao-thieu`, null, {
        params: { ghiChuThieuHang },
      })
      .then((res) => res.data);
  },

  khoXacMinhGiaoHang(diemDungId, imageUrl) {
    return api
      .post(`${BASE_URL}/diem-dung/${diemDungId}/kho-xac-minh`, null, {
        params: { imageUrl },
      })
      .then((res) => res.data);
  },

  khoHoanThanhPickup(diemDungId, tenNguoiLayHang, bienSoXeKhach, imageUrl) {
    const params = {
      tenNguoiLayHang,
      bienSoXeKhach,
      imageUrl,
    };
    return api
      .post(`${BASE_URL}/diem-dung/${diemDungId}/kho-hoan-thanh-pickup`, null, {
        params,
      })
      .then((res) => res.data);
  },
  // --- HẾT API MỚI ---
  khoBaoThieu(id, ghiChuKho) {
    return api
      .post(`${BASE_URL}/${id}/kho-bao-thieu`, null, { params: { ghiChuKho } })
      .then((res) => res.data);
  },
  khoHoachDinh(id, payload) {
    return api
      .post(`${BASE_URL}/${id}/kho-hoach-dinh`, payload)
      .then((res) => res.data);
  },
  khoSanSangGiao(id, payload) {
    return api
      .post(`${BASE_URL}/${id}/kho-san-sang-giao`, payload)
      .then((res) => res.data);
  },

  salesPlanStops(orderId, stops) {
    return api
      .put(`/api/don-hang/${orderId}/sales/plan-stops`, stops)
      .then((r) => r.data);
  },
  assignKho(orderId, khoUserId) {
    return api
      .put(`/api/don-hang/${orderId}/sales/assign-kho`, null, {
        params: { khoUserId },
      })
      .then((r) => r.data);
  }, // === ĐIỀU PHỐI ===

  listPool(params) {
    return api.get(`${BASE_URL}/pool`, { params }).then((res) => res.data);
  },

  adminAssignDonHang(phanCongId, orderIds) {
    return api
      .post(`${BASE_URL}/assign-to-trip`, orderIds, { params: { phanCongId } })
      .then((res) => res.data);
  }, // === TIỆN ÍCH LIÊN QUAN (giữ nguyên nếu đang dùng) ===

  getXeOptionsStatus() {
    return api.get("/api/xe/options-status").then((res) => res.data);
  },
  getTaiXeOptionsStatus() {
    return api
      .get("/api/nguoi-dung/tai-xe-options-status")
      .then((res) => res.data);
  },
  listAll(params) {
    return api.get(`${BASE_URL}/list-all`, { params }).then((res) => res.data);
  },
};

export default DonHangApi;
